import { render, staticRenderFns } from "./LogTable.vue?vue&type=template&id=4b2b3baf&"
import script from "./LogTable.vue?vue&type=script&lang=ts&"
export * from "./LogTable.vue?vue&type=script&lang=ts&"
import style0 from "./LogTable.vue?vue&type=style&index=0&id=4b2b3baf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports